export default {
    // market
    tabNews: '新聞',
    tabJobPostings: '職位發佈',
    marketSort: "排序",
    marketFilter: "過濾",
    marketReset: '重置',
    marketFilterGalleries: '領域',
    marketFilterCategories: '分類',
    recent: "近期",
    earlier: "更早",
    minuteAgo: "{count} 分鐘之前",
    hourAgo: "{count} 小時之前",
    dayAgo: "{count} 天之前",
    weekAgo: "{count} 周之前",
    on: '來自',
    readArticle: "閱讀文章",
    viewPosting: '查看招聘',
    moreNumber: "更多 {count} 家公司",



    // empty content text
    noNewsArticlesFound: "未找到新聞文章",
    nothingMatchSearch: "看起來我們找不到任何與您的搜索匹配的內容。 嘗試不同的關鍵字或稍後查看最新更新！",
    noJobListingsAvailable: "沒有可用的職位列表",
    noJobPostingsMatching: "看起來沒有符合您搜索條件的招聘資訊。 嘗試不同的關鍵字或稍後回來探索新的機會。",
    noAdsFound: "未找到廣告",
    noAdsFoundDesc: "目前未偵測到相關廣告，稍後回來查看最新投放動態。",
    noActivitiesTrackedYet: '尚未跟踪任何活動',
    noAdsMatch: "暫無符合搜尋的廣告",
    noAdsMatchDesc: "找不到與您的搜尋匹配的廣告。試著調整關鍵字，或稍後查看新的投放。",
    noTrackedAnyActivities: "我們還沒有跟踪這家公司的任何活動。 稍後查看更新",
    noTechnologiesFound: '未找到科技',
    cantFindAnyInformationOnTheTechnologies: "我們找不到這家公司使用的科技的任何資訊。 請繼續關注更新。",

    // company info
    seeLess: "收起",
    seeMore: "展開",

};